import { Differentiation } from 'approot/shared/differentiation/differentiation.constants';

export function isDifferentiatedAssessmentActivity(
  differentiation: Differentiation | null
) {
  return (
    differentiation === Differentiation.SelfAssessment ||
    differentiation === Differentiation.AnchorMap ||
    differentiation === Differentiation.UnitQuiz
  );
}
